import 'Lib/jquery.magnific-popup.js';
// @ts-ignore
import Swiper, { Navigation, Autoplay, Pagination } from 'swiper';
Swiper.use([Navigation, Autoplay, Pagination]);

declare var s7viewers: any;
declare var addthis: any;

const enum URLs {
    IMAGE_BASE_URL = 'https://images.baldwinhardware.com/is/image/',
    SCENE7_VIDEO_BASE_URL = 'https://images.baldwinhardware.com/is/content/',
    SKINS_BASE_URL = 'https://images.baldwinhardware.com/is/image/skins/',
	DOWNLOAD_IMAGE_URL = '/product/downloadimage?imageurl=',
}

const enum CONFIG {
    DEFAULT_SKIN = 'CONFIG.DEFAULT_SKIN',
}

let module: any = {};

module.getParameterByName = (name, url?) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

//strip out empty items in array
module.cleanArray = (actual) => {
    var newArray = [];
    for (var i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i]);
        }
    }
    return newArray;
};

module.checkForBeginningAndEnd = () => {
    let $selectedSlide = $('.swiper-slide-selected');
    let $nextArrow = $('.js-next-arrow');
    let $prevArrow = $('.js-prev-arrow');
    !$selectedSlide.next('.swiper-slide').length ? $nextArrow.addClass('disabled') : $nextArrow.removeClass('disabled');
    !$selectedSlide.prev('.swiper-slide').length ? $prevArrow.addClass('disabled') : $prevArrow.removeClass('disabled');
};

module.passIDBuildList = () => {
    // here were grabbing query string param values that get passed through so we can work with the data

    let queryStringValues = module.getParameterByName('ids');
    let selectedItemID = module.getParameterByName('selectedItem');

    //performing a split on the ids coming through
    let splitValues = queryStringValues.split(',');
    let joinedValues = splitValues.join(',');

    //perform our string splits to get different segments of incoming data
    let imageIds = joinedValues.split('clippedids:')[0] != null ? joinedValues.split('clippedids:')[0] : '';
    let galleryimageIds = joinedValues.split('clippedids:')[0] != null ? joinedValues.split('clippedids:')[0] : '';    
    let clippedSegment = joinedValues.split('clippedids:')[1] != null ? joinedValues.split('clippedids:')[1] : '';
    let clippedimageIds = clippedSegment.split('combinedids:')[0] != null ? clippedSegment.split('combinedids:')[0] : '';    
    let combinedSegment = joinedValues.split('combinedids:')[1] != null ? joinedValues.split('combinedids:')[1] : '';
    let combinedimageIds = combinedSegment.split('vignetteids:')[0] != null ? combinedSegment.split('vignetteids:')[0] : '';   
    let vignetteSegment = joinedValues.split('vignetteids:')[1] != null ? joinedValues.split('vignetteids:')[1] : '';
    let vignetteimageIds = vignetteSegment.split('supplementaryids:')[0] != null ? vignetteSegment.split('supplementaryids:')[0] : '';    
    let supplementarySegment = joinedValues.split('supplementaryids:')[1] != null ? joinedValues.split('supplementaryids:')[1] : '';
    let supplementaryimageIds = supplementarySegment.split('lifestyleids:')[0] != null ? supplementarySegment.split('lifestyleids:')[0] : '';    
    let lifestyleSegment = joinedValues.split('lifestyleids:')[1] != null ? joinedValues.split('lifestyleids:')[1] : '';
    let lifestyleimageIds = lifestyleSegment.split('roomids:')[0] != null ? lifestyleSegment.split('roomids:')[0] : '';    
    let roomSegment = joinedValues.split('roomids:')[1] != null ? joinedValues.split('roomids:')[1] : '';
    let roomimageIds = roomSegment.split('remainingids:')[0] != null ? roomSegment.split('remainingids:')[0] : '';    
    let remainingSegment = joinedValues.split('remainingids:')[1] != null ? joinedValues.split('remainingids:')[1] : '';
    let remainingimageIds = remainingSegment.split('threesixty:')[0] != null ? remainingSegment.split('threesixty:')[0] : ''; 
    let threeSixtyIds = joinedValues.split('threesixty:')[1] != null ? joinedValues.split('threesixty:')[1] : '';
    

    //concatenate and check for length of combined types
    let concatenatedString = galleryimageIds.concat(clippedimageIds, combinedimageIds, vignetteimageIds, supplementaryimageIds, lifestyleimageIds, roomimageIds, remainingimageIds, threeSixtyIds);
    let itemsLength = module.cleanArray(concatenatedString.split(',')).length;

    //create objects from specific segments
    let allImagesArray = module.cleanArray(concatenatedString.split(','));
    let galleryimagesArray = module.cleanArray(galleryimageIds.split(','));
    let clippedimagesArray = module.cleanArray(clippedimageIds.split(','));
    let combinedimagesArray = module.cleanArray(combinedimageIds.split(','));
    let vignetteimagesArray = module.cleanArray(vignetteimageIds.split(','));
    let supplementaryimagesArray = module.cleanArray(supplementaryimageIds.split(','));
    let lifestyleimagesArray = module.cleanArray(lifestyleimageIds.split(','));
    let roomimagesArray = module.cleanArray(roomimageIds.split(','));
    let remainingimagesArray = module.cleanArray(remainingimageIds.split(','));  
    let threeSixtyArray = module.cleanArray(threeSixtyIds.split(','));


    //need to seperate out mutliple id from single id so split does not fail if only 1 id.
    let properID = selectedItemID != null ? selectedItemID : allImagesArray[0];
    let isSingleID = itemsLength < 2 || module.getParameterByName('singleImage');
    let $body = $('body');
    let fullImageUrl = '';

    // full image url
    if (allImagesArray.length) {
       fullImageUrl = URLs.IMAGE_BASE_URL + properID + '?$wei-fullResProduct$';
    }  

    //setup other vars
    let $carousel = $('.js-product-carousel');

    //check for a query param indicating that there is only 1 id coming through and add class so we can style differently
    if (isSingleID || itemsLength < 2) {
        $body.addClass('single-element');
    }

    //if there is more than one id coming through then loop through the ids and add the image to carousel, if not we dont do this.
    if (!isSingleID)
     { 
        if(roomimagesArray.length)
        {
            $.each(roomimagesArray, function (i) {
                let theID = roomimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Room Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
        }
        if(lifestyleimagesArray.length)
        {
            $.each(lifestyleimagesArray, function (i) {
                let theID = lifestyleimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Lifestyle Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
        }  
        if(vignetteimagesArray.length)
        {
            $.each(vignetteimagesArray, function (i) {
                let theID = vignetteimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Vignette Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
        } 
        if(clippedimagesArray.length)
        {
            $.each(clippedimagesArray, function (i) {
                let theID = clippedimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Clipped Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
        } 
        if(combinedimagesArray.length)
        {
            $.each(combinedimagesArray, function (i) {
                let theID = combinedimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Combined Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
        }       
        if(supplementaryimagesArray.length)
        {
            $.each(supplementaryimagesArray, function (i) {
                let theID = supplementaryimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Supplementary Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
        }       
        if(remainingimagesArray.length)
        {
            $.each(remainingimagesArray, function (i) {
                let theID = remainingimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Remaining Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
        }  
        //insert 360 Images into the carousel
        $.each(threeSixtyArray, function (i) {
            var theID = threeSixtyArray[i];
            var encodedID = theID.replace('-', '%2D').replace(' ', '%20');
            $(`<div class="product-carousel__list-item swiper-slide">
					<a href="#" data-id="${theID}" class="js-carousel-link-threesixty product-carousel__link">
						<i class="icon icon-logo"></i>
						<img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$features$" class="product-carousel__img" alt="360 Image of ${encodedID}">
					</a>
				</div>`).appendTo($carousel);
        });
      /*  if(marketingvideoArray.length)
        {
        //insert youtube video thumbs into carousel
            $.each(marketingvideoArray, function (i) {
                var theID = marketingvideoArray[i];
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link-youtube product-carousel__link">
                            <img src="https://img.youtube.com/vi/${theID}/mqdefault.jpg" class="product-carousel__img" alt="YouTube Thumbnail for Video ${theID}">
                            <div class="icon-logo"><span class="icon-play"></span></div>
                        </a>
                    </div>`).appendTo($carousel);
            });
        }*/
        if(galleryimagesArray.length)
        {
            $.each(galleryimagesArray, function (i) {
                let theID = galleryimagesArray[i];
                let encodedID = theID.replace('-', '%2D').replace(' ', '%20');
                $(`<div class="product-carousel__list-item swiper-slide">
                        <a href="#" data-id="${theID}" class="js-carousel-link product-carousel__link">
                            <img src="${URLs.IMAGE_BASE_URL}/${encodedID}?$feature$" class="product-carousel__img" alt="Gallery Image for ${encodedID}">
                        </a>
                    </div>`).appendTo($carousel);
            });
        }      
    }

    // Swiper seems to expand slides fill the available space, so if there are only two we'll have to make the carousel shorter
    if (itemsLength < 3) {
        $('.swiper-container').addClass('swiper-container--short');
    }

    //initialize swiper with the current slide set to 0 if there is no selected item being passed through a query param
    //OR if selected item is being passed through we set the initial slide to the selected items parent index value

    let slidesPerView = Math.min(itemsLength, 3);
    let mySwiper;

    if (!isSingleID) {
        var wrapperElements = document.querySelectorAll('.product-carousel__left-col-content');

        //need to do this because our arrows our outside of swiper container
        for (var i = 0; i < wrapperElements.length; i++) {
            var el = wrapperElements[i];
            var swiper = el.querySelector('.swiper-container');
            var nx = el.querySelector('.swiper-button-next');
            var pr = el.querySelector('.swiper-button-prev');

            //@ts-ignore
            mySwiper = new Swiper(swiper, {
                direction: window.innerWidth >= 768 ? 'vertical' : 'horizontal',
                slidesPerView: slidesPerView,
                spaceBetween: 20,
                init: false,
                initialSlide: selectedItemID != null ? $(`a[data-id="${selectedItemID}"]`).parent().index() : 0,
                keyboardControl: true,

                navigation: {
                    nextEl: nx,
                    prevEl: pr,
                },
            });
        }
    }

    if (!isSingleID) {
        mySwiper.on('init', function () {
            setTimeout(function () {
                if (selectedItemID != null) {
                    mySwiper.activeIndex = $(`a[data-id="${selectedItemID}"]:first`).parent().index();
                }
                if (mySwiper.activeIndex == -1) {
                    mySwiper.activeIndex = 0;
                }
                $('.swiper-slide').removeClass('swiper-slide-selected');
                $(mySwiper.slides[mySwiper.activeIndex]).addClass('swiper-slide-selected');
                $(mySwiper.slides[mySwiper.activeIndex]).find('a[class^="js-carousel-link"]').trigger('click');
            }, 300);
        });
    }

    // Set the download link to match the large image
    let $iconsBlockLink = $('.icons-block__link');
    $iconsBlockLink.eq(0).attr('href', fullImageUrl);
    $iconsBlockLink.eq(0).attr('download', fullImageUrl);


    if (allImagesArray.length) {
        let s7basiczoom_div = new s7viewers.BasicZoomViewer({
            containerId: 's7basiczoom_div',
            params: {
                asset: properID,
                serverurl: URLs.IMAGE_BASE_URL,
                contenturl: URLs.SCENE7_VIDEO_BASE_URL,
                config: CONFIG.DEFAULT_SKIN,
            },
        }).init();
    }

    if (mySwiper) {
        mySwiper.init();

        mySwiper.on('resize', function () {
            mySwiper.update();
        });
    }

    //When we click on a carousel item link in the modal were reinitializing the BasicZoomViewer with the correct asset id
    $body.on('click', '.js-carousel-link', function (e) {
        $('.js-download-messaging').removeClass('d-none');
        $('#s7viewer').remove();
        $('#s7basiczoom_div').remove();
        $('.embed-responsive').remove();
        $('.icons-list').removeAttr('style');

        $(`<div id="s7basiczoom_div" />`).prependTo($('.product-carousel__large-area'));
        let s7basiczoom_div: any = new s7viewers.BasicZoomViewer();
        $('.swiper-slide').removeClass('swiper-slide-selected');
        $(this).parent('.swiper-slide').addClass('swiper-slide-selected');
        let idOfElement = $(this).data('id');
        let zoomViewerParent = $('#s7basiczoom_div');
        e.preventDefault();
        zoomViewerParent.empty();
        module.checkForBeginningAndEnd();

      //  let fullImageUrl = URLs.IMAGE_BASE_URL + idOfElement + '?$bal-fullResProduct$';
        //console.log(fullImageUrl);
        //console.log(s7basiczoom_div);

        // Update the download link to match the large image
        //$('.icons-block__link').eq(0).attr('href', fullImageUrl);
		$('.icons-block__link').eq(0).attr('href', URLs.DOWNLOAD_IMAGE_URL + URLs.IMAGE_BASE_URL + idOfElement + "&imagename="+ idOfElement);

        s7basiczoom_div = new s7viewers.BasicZoomViewer({
            containerId: 's7basiczoom_div',
            params: {
                asset: idOfElement,
                serverurl: URLs.IMAGE_BASE_URL,
                contenturl: URLs.SCENE7_VIDEO_BASE_URL,
                config: CONFIG.DEFAULT_SKIN,
            },
        }).init();

        //console.log(s7basiczoom_div);
    });

    $body.on('click', '.js-prev-arrow', function (e) {
        let $selectedSlide = $('.swiper-slide-selected');
        if ($selectedSlide.prev('.swiper-slide').length) {
            $('.js-next-arrow').removeClass('disabled');
            $selectedSlide.prev('.swiper-slide').find('a[class^="js-carousel-link"]').trigger('click');
        } else {
            $(this).addClass('disabled');
        }
        e.preventDefault();
    });

    $body.on('click', '.js-next-arrow', function (e) {
        let $selectedSlide = $('.swiper-slide-selected');
        if ($selectedSlide.next('.swiper-slide').length) {
            $('.js-prev-arrow').removeClass('disabled');
            $selectedSlide.next('.swiper-slide').find('a[class^="js-carousel-link"]').trigger('click');
        } else {
            $(this).addClass('disabled');
        }
        e.preventDefault();
    });

    $body.on('click', '.js-carousel-link-youtube', function (e) {
        $('#s7viewer').remove();
        var $this = $(this);
        var $youtubeID = $this.data('id');
        $('.icons-list').hide();
        $('#s7basiczoom_div').remove();
        $('.embed-responsive').remove();
        e.preventDefault();
        $('.swiper-slide').removeClass('swiper-slide-selected');
        $(this).parent('.swiper-slide').addClass('swiper-slide-selected');
        $('.js-download-messaging').addClass('d-none');
        $(`<div class="embed-responsive embed-responsive-16by9"><iframe width="845" height="476" src="https://www.youtube.com/embed/${$youtubeID}?rel=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`).prependTo(
            $('.product-carousel__right-col')
        );
        module.checkForBeginningAndEnd();
    });

    $body.on('click', '.js-carousel-link-scene7', function (e) {
        $('#s7viewer').remove();
        var $this = $(this);
        $('.icons-list').hide();
        var $scene7ID = $this.data('id');
        var encodedID = $scene7ID.replace('-', '%2D').replace(' ', '%20');
        $('#s7basiczoom_div').remove();
        $('.embed-responsive').remove();
        $('.swiper-slide').removeClass('swiper-slide-selected');
        $(this).parent('.swiper-slide').addClass('swiper-slide-selected');
        e.preventDefault();
        $(`<div class="embed-responsive embed-responsive-16by9"><video width="845" height="476" id="scene7Vid" controls autoplay>
                <source src="${URLs.SCENE7_VIDEO_BASE_URL}/${encodedID}" type="video/mp4">
					Your browser does not support the video tag.
				</video></div>`).prependTo($('.product-carousel__right-col'));
        ($('#scene7Vid').get(0) as any).play();
        module.checkForBeginningAndEnd();
    });

    $body.on('click', '.js-carousel-link-threesixty', function (e) {
        $('#s7basiczoom_div').remove();
        $('#s7viewer').remove();
        $('.embed-responsive').remove();
        $(`<div id="s7viewer" />`).prependTo($('.product-carousel__right-col'));
        var spinViewer = new s7viewers.SpinViewer();
        var $this = $(this);
        $('.icons-list').hide();
        var $theeSixtyID = $this.data('id');
        $('.swiper-slide').removeClass('swiper-slide-selected');
        $(this).parent('.swiper-slide').addClass('swiper-slide-selected');

        var spinViewerParent = $('#s7viewer');

        e.preventDefault();
        spinViewerParent.empty();

        var spinViewer = new s7viewers.SpinViewer({
            containerId: 's7viewer',
            params: {
                asset: $theeSixtyID,
                serverurl: URLs.IMAGE_BASE_URL,
            },
        }).init();
        module.checkForBeginningAndEnd();
    });

    setTimeout(function () {
        $('.js-load-indicator').removeClass('state-visible');
        $('.js-load-indicator-cover').removeClass('state-visible');
    }, 1200);
};

module.init = function () {
    module.passIDBuildList();
};

document.addEventListener('DOMContentLoaded', () => {
    module.init();
});
